import { render, staticRenderFns } from "./PracticalTraining.vue?vue&type=template&id=da98a81c&scoped=true&"
import script from "./PracticalTraining.vue?vue&type=script&lang=js&"
export * from "./PracticalTraining.vue?vue&type=script&lang=js&"
import style0 from "./PracticalTraining.vue?vue&type=style&index=0&id=da98a81c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da98a81c",
  null
  
)

export default component.exports